import actions from './actions';
import mutations from './mutations';

const state = {
    startDate: null,
    endDate: null,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
